
class Sticky {
  
    main = null
    parent = null
    target = null
    links = null
    anchors = null
    interval = false
    startPoint = 0
    offsetTop = 0
    offsetBottom = 0
    spaceTop = 0
    way = 0
    limitWay = 0
    isMobile = false

    constructor( element ){

        this.isMobile = ( this.vpWidth() <= 680 )

        this.main = document.querySelector( 'main' )
        this.target = element
        this.parent = element.parentElement
        this.spaceTop = parseInt( this.objectGet( this.parent.dataset, 'spaceTop', 0 ) )
        
        this.extractAnchors()
        this.setLimits()

        // Actualize
        if( this.interval ){ clearInterval( this.interval )}
        this.interval = setInterval( async () => { 
            this.extractAnchors()
        }, 500 )

        window.addEventListener( 'scroll', () => { 
            this.checkScroll()
        })
        window.addEventListener( 'resize', () => { 
            this.setLimits()
        })
        window.addEventListener( 'click', ( event ) => {
            this.bindClick( event )
        })

    }

    bindClick( event ){

        if( this.hasParent( event.target, 'dados-left' ) ){

            if( this.target.classList.contains( 'opened' ) ){
                this.close()
            }
            else {
                event.preventDefault()
                this.open()
            }

        }
        else {
            this.close()
        }

    }

    open(){
        this.target.classList.add( 'opened' )
    }

    close(){
        this.target.classList.remove( 'opened' )
    }

    getOffset( el ){
        const rect = el.getBoundingClientRect();
        return {
            left: rect.left + window.scrollX,
            top: rect.top + window.scrollY
        }
    }

    setLimits(){

        const parentPos = this.getOffset( this.parent );

        this.startPoint = parentPos.top - this.spaceTop
        this.target.style.position = 'relative'
        this.target.style.maxWidth = this.parent.offsetWidth + 'px'

        try {
            this.offsetTop = parseInt( this.css( this.parent, 'padding-top' ) ) + this.spaceTop
            this.offsetBottom = parseInt( this.css( this.parent, 'padding-bottom' ) )
        }
        catch( error ){
            this.offsetTop = 0
            this.offsetBottom = 0
        }

        this.way = ( this.parent.offsetHeight - this.target.offsetHeight - this.offsetTop - this.offsetBottom )
        this.limitWay = Math.round( this.startPoint + this.way ) + this.spaceTop

        this.checkScroll()

    }

    async extractAnchors(){

        this.links = this.target.querySelectorAll( 'ul a' )
        this.anchors = []
        for( let a = 0; a < this.links.length; a++ ){
            const id = this.extractId( this.links[a] )
            this.links[a].anchor = this.main.querySelector( `#${id}` )
            this.anchors.push( this.links[a] )
        }
    
    }

    checkScroll(){

        if( this.isMobile !== true ){
            
            // Top page positioun
            const scrollTop = this.scrollTop()

            // Sticky or not
            if( scrollTop >= this.startPoint ){

                if( scrollTop >= this.limitWay ){
                    this.target.style.position = 'absolute'
                    this.target.style.top = ''
                    this.target.style.bottom = this.offsetBottom + 'px'
                }
                else {
                    this.target.style.position = 'fixed'
                    this.target.style.top = this.offsetTop + 'px'
                    this.target.style.bottom = ''
                }
            } 
            else {
                this.target.style.position = 'relative'
                this.target.style.top = ''
                this.target.style.bottom = ''
            }

        }

        // Menu element active
        this.checkAnchors()

    }

    extractId( link ){
        return link.href.split('#').pop().split('?').shift()
    }

    checkAnchors(){

        // Elements
        let fixed = false
        let nearItem = false

        // Scroll end
        const scrollEnded = this.scrollEnd()
        if( scrollEnded ){
            const last = this.links[this.links.length - 1]
            fixed = last
        }

        // Search nearest
        let near = 99999999
        for( const link of this.links ){

            const slug = this.extractId( link )
            
            link.classList.remove( 'active' )
            if( !fixed && link.anchor ){
                
                var rect = link.anchor.getBoundingClientRect()
                const distance = ( rect.top < 0 ? ( rect.top * -1 ) : rect.top )
                if( distance < near ){
                    near = distance
                    nearItem = link
                }

            }
            
        }

        // If have fixed or nearest
        if( fixed ){
            fixed.classList.add( 'active' )
        }
        else if( nearItem ){
            nearItem.classList.add( 'active' )
        }

    }

    css( element, style){
        let __return
        try {
            __return = window.getComputedStyle( element, null ).getPropertyValue( style )
        } 
        catch(e) {
            __return = element.currentStyle[style]
        } 
        return __return
    }

    scrollTop(){
        return ( window.scrollY || window.pageYOffse );
    }
    
    vpWidth(){
        return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    }

    scrollEnd(){
        return ( ( window.innerHeight + window.scrollY ) >= document.body.offsetHeight )
    }

    hasParent( element, classname ){
        if( element.classList !== undefined && element.classList.contains( classname ) ) return true
        return element.parentNode && this.hasParent( element.parentNode, classname )
    }

    objectGet( object, key, notfound = false ){

        if( object === undefined || !object ) return notfound

        if( object[ key ] !== undefined && object[ key ] !== null && object[ key ] !== false && object[ key ] !== '' ){
            return object[ key ]
        }
        else {
            return notfound
        }
    }

}

const initStickyes = () => {
    const items = document.querySelectorAll( '.dados-left' )
    if( items.length ){
        for( item of items ){
            new Sticky( item )
        }
    }
}

window.addEventListener( 'DOMContentLoaded', () => {
    setTimeout( () => {
        initStickyes()
    }, 500 )
})
